import { render, staticRenderFns } from "./ColourPicker.vue?vue&type=template&id=5f393c7e&scoped=true"
import script from "./ColourPicker.vue?vue&type=script&lang=js"
export * from "./ColourPicker.vue?vue&type=script&lang=js"
import style0 from "./ColourPicker.vue?vue&type=style&index=0&id=5f393c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f393c7e",
  null
  
)

export default component.exports